// extracted by mini-css-extract-plugin
module.exports = {"addImage":"UploadImageButton_addImage__2G0_l","images":"UploadImageButton_images__1HYDn","disabled":"UploadImageButton_disabled__PQiOr"};